import { jsx as _jsx } from "react/jsx-runtime";
import queryString from 'query-string';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMessengers } from 'hooks/useMessengers';
import { DixaMessengerCsatSettingTabs, DixaMessengerPage, } from '../page/DixaMessengerPage';
import { DixaMessengerCSAT } from '../page/types';
export const initiallyActiveTabQueryParamName = 'initiallyActiveTab';
DixaMessengerPanel.PAGE = 'messenger';
export function DixaMessengerPanel({ loadDixaMessengerSettingsAllLevels, globalSettings, contactPointSettings, languagesSettings, updateGlobalSettings, initializeDixaMessengerCsat, updateLanguageLevelSettings, updateContactPointLevelSettings, }) {
    const navigate = useNavigate();
    const { items, asyncStatus } = useMessengers({ limit: 200 });
    useEffect(() => {
        loadDixaMessengerSettingsAllLevels();
    }, [loadDixaMessengerSettingsAllLevels]);
    const messengers = items.map(({ id, name }) => {
        var _a;
        const correspondingSettings = (_a = contactPointSettings.list) === null || _a === void 0 ? void 0 : _a.find(({ contactPoint }) => contactPoint === id);
        if (correspondingSettings) {
            return {
                id,
                name,
                enabled: correspondingSettings.enabled,
                settings: correspondingSettings,
            };
        }
        return {
            id,
            name,
            enabled: false,
            settings: null,
        };
    });
    function getEnrichedLanguagesWithSettings() {
        return languagesSettings.list.map(({ code, label, settings }) => ({
            isSetup: settings !== null,
            ratingStyle: settings === null || settings === void 0 ? void 0 : settings.customization.look_and_feel,
            enabled: (settings === null || settings === void 0 ? void 0 : settings.enabled) || false,
            name: label,
            code,
            settings,
        }));
    }
    function redirectToLanguageCustomizationPage(language) {
        var _a;
        const pathname = language.isSetup
            ? `/settings/satisfaction/${DixaMessengerPanel.PAGE}/${language.code}/edit/${(_a = language.settings) === null || _a === void 0 ? void 0 : _a.id}`
            : `/settings/satisfaction/${DixaMessengerPanel.PAGE}/${language.code}/create/`;
        navigate(pathname);
    }
    function handleGlobalStatusChange(change) {
        // If we have global settings already, update it
        if (globalSettings.values) {
            updateGlobalSettings(Object.assign(Object.assign({}, globalSettings.values), { enabled: change.newStatus }));
        }
        else {
            // Otherwise csat is not initialized, so initialize if needed.
            if (change.newStatus === true) {
                initializeDixaMessengerCsat();
            }
        }
    }
    function handleLanguageStatusChange({ language, newStatus, }) {
        var _a;
        // the default language should not be allowed to be disabled.
        if (DixaMessengerCSAT.defaultLanguage === language.code) {
            return;
        }
        const payload = {
            id: (_a = language.settings) === null || _a === void 0 ? void 0 : _a.id,
            enabled: newStatus,
            channel: 'email',
        };
        updateLanguageLevelSettings(payload);
    }
    function isDixaMessengerCsatSetupGlobally() {
        return Boolean(globalSettings.values);
    }
    function isDixaMessengerCsatActiveGlobally() {
        var _a;
        return ((_a = globalSettings.values) === null || _a === void 0 ? void 0 : _a.enabled) || false;
    }
    function getInitiallyActiveTab() {
        let { initiallyActiveTab } = queryString.parse(location.search);
        if (Array.isArray(initiallyActiveTab)) {
            initiallyActiveTab = initiallyActiveTab[0];
        }
        const cleanedUpValue = initiallyActiveTab === null || initiallyActiveTab === void 0 ? void 0 : initiallyActiveTab.trim().toLowerCase();
        if (!cleanedUpValue) {
            return DixaMessengerCsatSettingTabs.Messengers;
        }
        switch (cleanedUpValue) {
            case DixaMessengerCsatSettingTabs.Messengers.toLowerCase():
                return DixaMessengerCsatSettingTabs.Messengers;
            case DixaMessengerCsatSettingTabs.LanguageLevelCustomizations.toLowerCase():
                return DixaMessengerCsatSettingTabs.LanguageLevelCustomizations;
            default:
                return DixaMessengerCsatSettingTabs.Messengers;
        }
    }
    return (_jsx(DixaMessengerPage, { existingMessengers: messengers, languages: getEnrichedLanguagesWithSettings(), onLanguageEditRequest: redirectToLanguageCustomizationPage, onMessengerStatusChange: updateContactPointLevelSettings, onGlobalStatusChange: handleGlobalStatusChange, onLanguageStatusChange: handleLanguageStatusChange, isLoadingMessengersList: asyncStatus === 'loading', isMessengerCsatActive: isDixaMessengerCsatActiveGlobally(), isMessengerCsatSetup: isDixaMessengerCsatSetupGlobally(), initiallyActiveTab: getInitiallyActiveTab() }));
}
